<template>
  <div>
    <button
      class="product-filter__button"
      :class="{'product-filter__button--active' : open}"
      :disabled="fixedBrand && !priceRange.length"
      @click="toggle()"
    >
      {{ $modeoL10n.filter_verb }}
    </button>

    <div class="product-filter__selected-filters">
      <template
        v-if="!open && selectedFilters.length <= 2"
      >
        <!-- eslint-disable vue/no-v-html -->
        <button
          v-for="(filter, index) in selectedFilters"
          :key="index"
          class="filter-text-tag filter-text-tag--small"
          :class="[selectedFilters.length > 2 ? 'filter-text-tag--never' : 'filter-text-tag--in-large']"
          @click="removeFilter(index)"
          v-html="$sanitize(filter.label)"
        />
        <!-- eslint-enable vue/no-v-html -->
      </template>
      <button
        v-if="!open && selectedFilters.length > 0"
        class="filter-number-tag"
        :class="[selectedFilters.length > 2 ? 'filter-number-tag--always' : 'filter-number-tag--in-small']"
        @click="toggle()"
      >
        {{ selectedFilters.length }}
      </button>
    </div>

    <div
      v-if="(!fixedBrand || priceRange.length) && open"
      class="product-filter__dropdown"
    >
      <div
        v-if="selectedFilters.length"
        class="product-filter__dropdown-section product-filter__dropdown-section--tags"
      >
        <!-- eslint-disable vue/no-v-html -->
        <button
          v-for="(filter, index) in selectedFilters"
          v-show="showFilter(filter)"
          :key="index"
          class="filter-text-tag"
          @click="removeFilter(index)"
          v-html="$sanitize(filter.label)"
        />
        <!-- eslint-enable vue/no-v-html -->

        <button
          class="link"
          @click="removeFilters()"
        >
          {{ $modeoL10n.remove_filters }}
        </button>
      </div>

      <div
        v-if="!fixedBrand"
        class="product-filter__dropdown-section product-filter__dropdown-section--with-more"
      >
        <p class="product-filter__dropdown-section__heading">
          {{ $modeoL10n.brand }}
        </p>

        <ul
          v-if="visibleBrands.length > 0"
          class="product-filter__options"
        >
          <li
            v-for="(brand) in visibleBrands"
            :key="brand.id"
            class="product-filter__option product-filter__option--checkbox"
          >
            <label class="product-filter__label">
              <input
                v-model="selectedBrands[brand.id]"
                class="checkbox-input"
                type="checkbox"
                :true-value="brand"
                @change="updateSelectedFilters({emitToParent: true})"
              >

              <!-- eslint-disable vue/no-v-html -->
              <span
                :class="[ 'checkbox-label', 'product-filter__option__value', { 'modeo-plus': brand.title == 'Modeo+' }]"
                v-html="$sanitize(brand.title)"
              />
              <!-- eslint-enable vue/no-v-html -->
              <span class="product-filter__option__count">{{ brand.count }}</span>
            </label>
          </li>
        </ul>
        <div v-if="visibleBrands.length == 0">
          {{ $modeoL10n.no_brands }}
        </div>
        <button
          v-if="brandsWhichHaveProducts().length > 5"
          class="product-filter__show-more show-more-button"
          :class="{ 'show-more-button--close': showAllBrands }"
          @click="toggleBrands()"
        >
          {{ showAllBrands ? $modeoL10n.hide : $modeoL10n.show_more + ' (' + (brandsWhichHaveProducts().length - 5) + ')' }}
        </button>
      </div>

      <div
        v-if="priceRange.length"
        class="product-filter__dropdown-section"
      >
        <p class="product-filter__dropdown-section__heading">
          {{ $modeoL10n.price }}
        </p>
        {{ price[0] | formatIntPrice }} – {{ price[1] | formatIntPrice }}
        <div class="price">
          <vue-slider
            ref="slider"
            v-model="price"
            :min="priceRange[0]"
            :max="priceRange[1]"
            :interval="priceRangeInterval"
            @drag-end="priceChanged()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component';
import _ from 'lodash';

export default {
    components: {
        vueSlider,
    },
    props: {
        priceRangeInterval: {
            type: Number,
            default: 50,
        },
        fixedBrand: {
            type: Object,
            default: () => {},
        },
    },
    data : function () {
        return {
            selectedBrands: {},
            fixedBrands: !_.isEmpty(this.fixedBrand ) ? [ this.fixedBrand] : [],
            fixedFilters: !_.isEmpty( this.fixedBrand ) ? [{type: 'brand', id: this.fixedBrand.id, label: this.fixedBrand.title}] : [],
            selectedFilters: [],
            open: false,
            price: [],
            showAllBrands: false,
            brands: [],
            priceRange: [],
            productCount: 0,
        }
    },

    computed: {
        visibleBrands: function() {
            if (this.productCount === 0) {
                return [];
            }

            if (this.fixedBrand) {
                return [this.fixedBrand];
            } else if (this.showAllBrands) {
                return this.brandsWhichHaveProducts();
            } else {
                return this.brandsWhichHaveProducts().slice(0,5);
            }
        },
    },

    watch: {

        priceRange: function(newPriceRange) {
            //Update max and min values
            if (this.price.length == 0) {
                this.price = newPriceRange;
                return;
            }

            if (this.isPriceSelected()) {

                // let's keep selected price inside limits
                if (this.price[0] < parseInt(newPriceRange[0])) {
                    this.price[0] = parseInt(newPriceRange[0])
                }

                if (this.price[1] > parseInt(newPriceRange[1])) {
                    this.price[1] = parseInt(newPriceRange[1]);
                }

            } else {
                this.price = [0, newPriceRange[1]];
            }

        },

    },

    created: function () {
        this.price = this.priceRange;
    },

    mounted: function () {

    },

    methods: {
        showFilter(filter) {
            if (filter.type == 'brand' && this.fixedBrand) {
                return false;
            } else {
                return true;
            }
        },

        isPriceSelected() {
            for (let i=0; i < this.selectedFilters.length; i++) {
                if (this.selectedFilters[i].type == 'price') {
                    return true;
                }
            }
            return false;
        },

        brandsWhichHaveProducts: function() {
            let brands = _.sortBy(this.brands.filter(function (brand) {
                if (brand.count > 0) {
                    return brand;
                }
            }), 'title');

            const stickyOmaModeo = _.remove(brands, brand => brand.slug === 'oma-modeo');
            const stickyModeoPlus = _.remove(brands, brand => brand.slug === 'modeo-plus');

            if (!_.isEmpty(stickyModeoPlus)) {
                brands.unshift(stickyModeoPlus[0]);
            }

            if (!_.isEmpty(stickyOmaModeo)) {
                brands.unshift(stickyOmaModeo[0]);
            }

            return brands;
        },

        findBrandsBySlugs(slugs) {
            if (typeof slugs === 'undefined') return [];
            let selectedBrands = [];
            for (let i = 0; i < this.visibleBrands.length; i++) {
                if (typeof this.visibleBrands[i] !== 'undefined' && slugs.indexOf(this.visibleBrands[i].slug) > -1) {
                    selectedBrands[i] = this.visibleBrands[i];
                } else {
                    selectedBrands[i] = undefined;
                }
            }
            return selectedBrands;
        },


        updateFilters(filters) {
            this.brands = _.clone(filters.brands);
            this.productCount = filters.productCount;
            this.priceRange = filters.priceRange;

            let selectedBrands = {};

            if (!_.isUndefined( filters.selectedBrands ) && filters.selectedBrands) {
                filters.selectedBrands.forEach((brandSlug) => {
                    const brand = this.findBrandBySlug(brandSlug);
                    selectedBrands[brand.id] = brand;
                });

                this.selectedBrands = selectedBrands;
            }

            if ( !this.isPriceSelected() ) {
                this.price = this.priceRange;
            }

            if ( !_.isUndefined( filters.selectedPriceRange ) && filters.selectedPriceRange && filters.selectedPriceRange.length > 1) {
              this.price = filters.selectedPriceRange;
            }

            this.updateSelectedFilters({emitToParent: false});
        },

        findBrandBySlug(slug) {
            return this.brands.filter((brand) => {
                return brand.slug === slug;
            })[0];
        },

        updateSelectedFilters(params) {
            let filters = [];

          if (!_.isUndefined(this.price) && this.price.length > 0 && (this.price[0] !== this.priceRange[0] || this.price[1] !== this.priceRange[1])) {
              const filter = {
                    type: 'price',
                    min: this.price[0],
                    max: this.price[1],
                    label: this.$options.filters.formatIntPrice(this.price[0]) + ' – ' + this.$options.filters.formatIntPrice(this.price[1]),
                }
                filters.push(filter);
            }

            const selectedBrands = _.values(this.selectedBrands);

            for (let i = 0; i < selectedBrands .length; i++) {
                if (typeof selectedBrands[i] !== 'undefined' && selectedBrands[i] !== false) {
                    const brand = selectedBrands[i];
                    const brandFilter = {
                        type: 'brand',
                        id: brand.id,
                        label: brand.title,
                    }
                    if (!this.fixedBrand || this.fixedBrand.id !== brandFilter.id) {
                        // Push all selected brands, but fixed brands
                        filters.push(brandFilter);
                    }
                }
            }

            this.selectedFilters = filters;

            //Get All Brand Filters...
            let allBrandFilters = selectedBrands.concat(this.fixedBrands);

            allBrandFilters = allBrandFilters.map(function(brand) {
                if (typeof brand !== 'undefined') {
                    return brand.slug;
                }
            }).filter(function(brand) {
                if (brand) {
                    return brand;
                }
            });


            let data = {
                brands: allBrandFilters,
            }

            if (this.isPriceSelected()) {
                data.priceRange = this.price
            }

            if (params && params.emitToParent) {
                this.$emit('filters-changed', data);
            }

        },

        removeFilter(index) {
            if (this.selectedFilters[index].type == 'price') {
                this.setPriceToDefault();
            }

            if (this.selectedFilters[index].type == 'brand') {
                const brandToRemove = this.selectedFilters[index].id;
                delete this.selectedBrands[brandToRemove];
            }

            this.updateSelectedFilters({emitToParent: true});
        },

        removeFilters() {
            this.setPriceToDefault();
            this.selectedBrands = [];
            this.updateSelectedFilters({emitToParent: true});
        },

        toggle() {
            this.open = !this.open;
            this.$emit('toggle', this.open);
        },

        close() {
            this.open = false;
            this.$emit('toggle', this.open);
        },

        priceChanged() {
            _.remove(this.selectedFilters, {
                type: "price",
            });

            const filter = {
                type: 'price',
                min: this.price[0],
                max: this.price[1],
                label: this.price[0] + ' – ' + this.price[1] + ' €',
            }

            this.selectedFilters.unshift(filter);
            this.updateSelectedFilters({emitToParent: true});
        },

        setPriceToDefault() {
            this.price = this.priceRange;
        },

        toggleBrands() {
            this.showAllBrands = !this.showAllBrands;
        },
    },
}
</script>
